(function() {
  var searchOrderInput = '#anonymousSearchOrderForm input';

  function focusInOut() {
    $('#anonymousSearchOrderForm .anonymous_holder.setTwoHolder input, .ph-searchorder-setTwoHolder input').focus(function() {
      $(this).parents('.anonymous_holder').addClass('enabled');
      $('#anonymousSearchOrderForm .anonymous_holder.setOneHolder').removeClass('enabled');
      $('#anonymousSearchOrderForm .setOneHolder .alert').remove();
      $('.ph-searchorder-setOneHolder').addClass('disabled');
    });
    $('#anonymousSearchOrderForm .anonymous_holder.setTwoHolder input, .ph-searchorder-setTwoHolder input').focusout(function() {
      var nullvalue = 0;

      $('#anonymousSearchOrderForm .anonymous_holder.setTwoHolder input, .ph-searchorder-setTwoHolder input').each(function() {
        if ($(this).val() !== '') {
          nullvalue = nullvalue + 1;
        }
      });

      if (nullvalue === 0) {
        $('#anonymousSearchOrderForm .anonymous_holder.setOneHolder').removeClass('disabled');
        $('#anonymousSearchOrderForm .anonymous_holder.setOneHolder input').attr('disabled', false);
        $('.ph-searchorder-setOneHolder').removeClass('disabled');
        $('.ph-searchorder-setTwoHolder').removeClass('enabled');
      }
    });

    $('#anonymousSearchOrderForm .anonymous_holder.setOneHolder input, .ph-searchorder-setOneHolder input').focus(function() {
      $(this).parents('.anonymous_holder').addClass('enabled');
      $('#anonymousSearchOrderForm .anonymous_holder.setTwoHolder').removeClass('enabled');
      $('#anonymousSearchOrderForm .setTwoHolder .alert').remove();
      $('.ph-searchorder-setTwoHolder').addClass('disabled');
    });
    $('#anonymousSearchOrderForm .anonymous_holder.setOneHolder input, .ph-searchorder-setOneHolder input').focusout(function() {
      var nullvalue = 0;

      /* eslint-disable sonarjs/no-identical-functions */
      $('#anonymousSearchOrderForm .anonymous_holder.setOneHolder input, .ph-searchorder-setOneHolder input').each(function() {
        /* eslint-enable sonarjs/no-identical-functions */
        if ($(this).val() !== '') {
          nullvalue = nullvalue + 1;
        }
      });

      if (nullvalue === 0) {
        $('#anonymousSearchOrderForm .anonymous_holder.setTwoHolder').removeClass('disabled');
        $('#anonymousSearchOrderForm .anonymous_holder.setTwoHolder input').attr('disabled', false);
        $('.ph-searchorder-setTwoHolder').removeClass('disabled');
        $('.ph-searchorder-setOneHolder').removeClass('enabled');
      }
    });
  }

  function mandate() {
    if (($.trim($('#poNumber').val()) !== '') && ($.trim($('#accountNumber').val()) !== '') && ($.trim($('#fromDate').val()) !== '') &&
      ($.trim($('#toDate').val()) !== '')) {
      $('#error_text').addClass('hidden');

      return true;
    }

    $('#error_text').removeClass('hidden');
    $(searchOrderInput).focus(function() {
      $('#error_text').addClass('hidden');
    });

    return false;
  }

  function setTwoHolderValidation() {
    if (mandate()) {
      var count = 0;

      $('.alert').remove();

      if (ACC.validation.numeric($.trim($('#accountNumber').val()))) {
        count = count + 1;
        $('#accountNumber').parents('.span-12.clear_fix').after($('.ph-numericErrorMsg').text());
      }

      if ($.trim($('#poNumber').val()) === '') {
        count = count + 1;
        $('#poNumber').parents('.span-12.clear_fix').after($('.ph-userPOErrorMsg').text());
      }

      if (count === 0) {
        return true;
      }

      return false;
    }

    $('#error_text').removeClass('hidden');
    $(searchOrderInput).focus(function() {
      $('#error_text').addClass('hidden');
    });

    return false;
  }

  var confirmationNumber = $('.ph-anonymousOrderSearch__setOneHolder').find('.ph-anonymousOrderSearch__confirmationOrder').attr('id'),
      $postalCodeMain = $('.ph-anonymousOrderSearch__setOneHolder').find('.ph-anonymousOrderSearch__postalCode'),
      postalCode = $postalCodeMain.attr('id'),
      confirmationNumberMainClass = 'ph-anonymousConfirmationOrder',
      postalCodeMainClass = 'ph-anonymousPostalCode',
      errorMainClass = '.ph-signup__error',
      currentStoreId = '#currentStoreId';

  function anonymousSearchAddError(idVal) {
    var errorMsgVal = $(idVal).parents(errorMainClass).parent().attr('data-wrongContent');

    $(idVal).parents(errorMainClass).addClass('form_field_error ph-form_field_error');
    $(idVal).parents(errorMainClass).find('.ph-register__emptyvalue').text(errorMsgVal);
  }

  function anonymousSearchRemoveError(idVal) {
    $(idVal).parents(errorMainClass).removeClass('form_field_error ph-form_field_error');
    $(idVal).parents(errorMainClass).find('.ph-register__emptyvalue').text('');
  }

  function validateConfirmationNumber() {
    if (ACC.validation.numeric($.trim($('#' + confirmationNumber).val()))) {
      anonymousSearchAddError('#' + confirmationNumber);
    } else {
      anonymousSearchRemoveError('#' + confirmationNumber);
    }
  }

  function validatePostalCode() {
    if (ACC.validation.postalCode($.trim($('#' + postalCode).val()))) {
      anonymousSearchAddError('#' + postalCode);
    } else {
      anonymousSearchRemoveError('#' + postalCode);
    }
  }

  function validateConfirmationNumberMain(confirmationNumberInputVal) {
    if (confirmationNumberInputVal) {
      validateConfirmationNumber();
    } else {
      ACC.registerPage.isEmptyValue(confirmationNumberMainClass);
    }
  }

  function validatePostalCodeMain(postalCodeInputVal) {
    if ($(currentStoreId).val() === 'pcms-philips-gb' || $(currentStoreId).val() === 'pcms-philips-sg') {
      $postalCodeMain.addClass('ph-anonymousOrderSearch__otherlocale');
    }

    var postalCodeForGbAndSg = $postalCodeMain.hasClass('ph-anonymousOrderSearch__otherlocale');

    if (postalCodeInputVal && !postalCodeForGbAndSg) {
      validatePostalCode();
    } else {
      ACC.registerPage.isEmptyValue(postalCodeMainClass);
    }
  }

  function setOneHolderValidation() {
    validateConfirmationNumberMain($.trim($('#confirmationNumber').val()));
    validatePostalCodeMain($.trim($('#' + postalCode).val()));

    if ($('.ph-page-anonymousOrderSearch .form_field_error.ph-form_field_error').length > 0) {
      return false;
    }

    return true;
  }

  function validateanonymousSearchOrderForm() {
    var $accountNumber = $('#accountNumber'),
        $confirmationNumber = $('#confirmationNumber'),
        $poNumber = $('#poNumber'),
        $postalCode = $('#postalCode');

    $confirmationNumber.val($confirmationNumber.val().trim());
    $postalCode.val($postalCode.val().trim());
    $accountNumber.val($accountNumber.val().trim());
    $poNumber.val($poNumber.val().trim());

    if ($('.anonymous_holder.enabled').hasClass('setOneHolder')) {
      return setOneHolderValidation();
    }

    return setTwoHolderValidation();
  }

  $(document).on('submit', '#anonymousSearchOrderForm', function() {
    return validateanonymousSearchOrderForm();
  });

  $(document).on('blur', '#ph-anonymousConfirmationOrder', function() {
    validateConfirmationNumberMain($(this).find('input').val());
  });

  $(document).on('blur', '#ph-anonymousPostalCode', function() {
    validatePostalCodeMain($(this).find('input').val());
  });

  focusInOut();
})();

$(document).ready(function() {
  var count = 1,
      inputcount = 0,
      inputvalue = 0,
      searchOrderInput = '#anonymousSearchOrderForm input';

  if ($('#noradio').html() === 'false') {
    inputcount = 3;
    inputvalue = 1;
  } else {
    inputcount = 5;
    inputvalue = 3;
  }

  $('#anonymousSearchOrderForm .anonymous_holder.setTwoHolder input').each(function() {
    if ($(this).val() !== '') {
      $(this).parents('.anonymous_holder').addClass('enabled');
      $('#anonymousSearchOrderForm .setOneHolder .alert').remove();
    }
  });
  $('#anonymousSearchOrderForm .anonymous_holder.setOneHolder input').each(function() {
    if ($(this).val() !== '') {
      $(this).parents('.anonymous_holder').addClass('enabled');
      $('#anonymousSearchOrderForm .setTwoHolder .alert').remove();
    }
  });
  $('#anonymousSearchOrderForm button').click(function() {
    var flyoutDivShown = sessionStorage.getItem('flyoutDivShown');

    sessionStorage.clear();

    /* Setting back the session value for flyout as Session storage for flyout must not be cleared */
    if (flyoutDivShown !== null) {
      sessionStorage.setItem('flyoutDivShown', 'false');
    }

    $(searchOrderInput).each(function() {
      sessionStorage.setItem(String('inputvalue' + count), $(this).val());
      count = count + 1;
    });
  });

  $('.ph-searchorder-setTwoHolder input').each(function() {
    if ($(this).val() !== '') {
      $('.ph-searchorder-setOneHolder').addClass('disabled');
    }
  });
  $('.ph-searchorder-setOneHolder input').each(function() {
    if ($(this).val() !== '') {
      $('.ph-searchorder-setTwoHolder').addClass('disabled');
    }
  });

  $('.anonymousOrderSearchButton').click(function() {
    var flyoutDivShown = sessionStorage.getItem('flyoutDivShown');

    sessionStorage.clear();

    /* Setting back the session value for flyout as Session storage for flyout must not be cleared */
    if (flyoutDivShown !== null) {
      sessionStorage.setItem('flyoutDivShown', 'false');
    }
  });

  $('#anonymousSearchOrderForm #accountNumber, #anonymousSearchOrderForm #poNumber,#anonymousSearchOrderForm #fromDate,#anonymousSearchOrderForm #toDate').each(function() {
    $(this).val(sessionStorage.getItem(String('inputvalue' + inputcount)));
    inputcount = inputcount + 1;
  });

  $('#anonymousSearchOrderForm #confirmationNumber, #anonymousSearchOrderForm #postalCode').each(function() {
    $(this).val(sessionStorage.getItem(String('inputvalue' + inputvalue)));
    inputvalue = inputvalue + 1;
  });
});
